import { IInvoiceRespSchema, InvoiceSummaryResp } from '@monetize/types/app';
import { useInvoiceRevenueSchedule } from '../../../api/invoiceService';
import {
  MAccordion,
  MCenterModal,
  MPageHeader,
  MSkeleton,
  MVStack,
} from '../../../components/Monetize';
import { getAccountInvoicesRoute } from '../../../constants/routes';
import { InvoiceRevenueScheduleAccordionItem } from './InvoiceRevenueScheduleAccordionItem';

type InvoiceRevenueScheduleModalProps = {
  isOpen: boolean;
  invoice: IInvoiceRespSchema | InvoiceSummaryResp;
  onClose: () => void;
};

export const InvoiceRevenueScheduleModal = ({
  isOpen,
  invoice,
  onClose,
}: InvoiceRevenueScheduleModalProps) => {
  const { data: revenueSchedule, isLoading } = useInvoiceRevenueSchedule(
    invoice.id,
  );

  const title = (
    <MVStack alignItems="flex-start">
      <MPageHeader
        title="Revenue Schedule"
        parentLink={getAccountInvoicesRoute(invoice.account.id)}
        parentLinkTitle={invoice.account.accountName}
        copyUrl
        id={invoice.id}
        containerProps={{ mb: 0 }}
      ></MPageHeader>
    </MVStack>
  );

  return (
    <MCenterModal
      size="5xl"
      isOpen={isOpen}
      onClose={onClose}
      // modalTitle="Revenue Schedule"
      modalHeaderProps={{ fontSize: 'lg', display: 'flex' }}
      renderModalTitleActions={() => title}
      // TODO: header stuff
    >
      {isLoading && (
        <>
          <MSkeleton w="full" py={5} />
          <MSkeleton w="full" py={5} />
          <MSkeleton w="full" py={5} />
        </>
      )}
      {revenueSchedule && (
        <MAccordion multiple defaultValue={['0']} variant="default">
          {revenueSchedule.schedulesByProduct.map((item, i) => (
            <InvoiceRevenueScheduleAccordionItem
              key={i}
              value={String(i)}
              productRevRecSchedule={item}
              currency={invoice.currency}
            />
          ))}
        </MAccordion>
      )}
    </MCenterModal>
  );
};
